import React from 'react';
import { Dialog } from '@mui/material';
// import {IconButton } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

/**
 * A full-screen dialog component to display a series of responsive menu images.
 * @param {object} props - The component props.
 * @param {object} props.menuData - The data for the menu to display.
 * @param {Array<object>} props.menuData.images - An array of image objects.
 * @param {string} props.menuData.images[].id - A unique ID for the image (for React key).
 * @param {string} props.menuData.images[].desktopSrc - The URL for the desktop version of the image.
 * @param {string} props.menuData.images[].mobileSrc - The URL for the mobile version of the image.
 * @param {string} props.menuData.images[].alt - The alt text for the image.
 * @param {Function} props.onClose - The function to call when the dialog should be closed.
 */
const FullScreenImageViewer = ({ menuData, onClose }) => {
  // Guard clause: If there's no data or no images, render nothing.
  if (!menuData || !menuData.images || menuData.images.length === 0) {
    return null;
  }

  return (
    <Dialog
      open={true} // If this component renders, the dialog is always open
      onClose={onClose}
      fullScreen
      // Use PaperProps to style the container of the dialog itself
      PaperProps={{
        style: styles.dialogPaper,
      }}
    >
      {/* A close button is crucial for usability in a full-screen modal */}
      {/* <IconButton
        aria-label="close"
        onClick={onClose}
        sx={styles.closeButton} // sx prop is great for one-off MUI component styles
      >
        <CloseIcon />
      </IconButton> */}

      {/* This container will hold and scroll through the images */}
      <div style={styles.container}>
        {menuData.images.map((image) => (
          <picture key={image.id} style={styles.picture}>
            <source media="(min-width: 768px)" srcSet={image.desktopSrc} />
            <img
              src={image.mobileSrc}
              alt={image.alt}
              style={styles.image}
            />
          </picture>
        ))}
      </div>
    </Dialog>
  );
};

// JSS (CSS-in-JS) for styling the component
const styles = {
  dialogPaper: {
    backgroundColor: '#f0f0f0', // A soft background color
  },
  closeButton: {
    position: 'absolute',
    right: 16,
    top: 16,
    color: 'grey',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1301, // Ensure it's above the content
  },
  container: {
    width: '100%',
    height: '100%',
    paddingTop: '20px', // Add padding to not be obscured by the close button
    paddingBottom: '40px',
    overflowY: 'auto', // Enable vertical scrolling
    textAlign: 'center', // Center the images
  },
  picture: {
    display: 'block',
    marginBottom: '1rem', // Space between menu pages
  },
  image: {
    maxWidth: '95%', // Don't let images touch the screen edges
    height: 'auto', // Maintain aspect ratio
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
  },
};

export default FullScreenImageViewer;